import React from "react";
import styles from "./index.module.scss";
import clsx from "clsx";
import translate from "../../../../i18n/translate";
import {useSelector} from "react-redux";
import {FaBan} from "react-icons/fa";
import {formatPrice} from "../../../../utils/formatPrice";
import {Space} from "antd";

export default function Apartment({ apartment, onApartmentClick, classNames,smallChess, isSmoke, disabled }) {
  const {rate} = useSelector(state => state.rate)



  return (
    <div
      className={clsx(styles["apartment-container"], ...classNames)}
      onClick={disabled ? undefined : onApartmentClick}
      style={{
        ...(smallChess
            ? { width: "50px", height: "50px" }
            : {}),

        ...(apartment?.notSale
            ? {
              pointerEvents: "none",
              opacity: 0,
              cursor: "not-allowed"
            }
            : {}),
        ...(isSmoke
            ? { border: "6px solid black" }
            : {}),
        ...(disabled
            ? { opacity: 0.5, pointerEvents: "none", cursor: "not-allowed" }
            : {})
      }}

    >
      {
        apartment?.notSale ? <div className={styles["not-sales"]}>
            {/*{smallChess? <FaBan className={'3xl'}/>:translate("status.not_for_sale")}*/}
        </div>
            :
            smallChess ? <>
                  <div className={styles.smallChess} >
                    <p>{apartment.apartment_number}</p>
                  </div>
                </>
                :
                <>
                    <div className={styles["apartment-card-top"]}>

                        <p>
                            &#8470;
                            {/*{translate("apartment.apartment_number")}{" "}*/}
                            <b>
                                {apartment.apartment_number}
                            </b>
                        </p>
                        <p className={styles["apartment-number"]}>
                            <b>{apartment?.number}{apartment?.additionalArea ? "+" : ""} </b>
                        </p>
                    </div>
                    {
                        apartment.orders?.length > 0 ?
                            <>
                        <p className={styles['apartment-sold']}>
                            {apartment.orders[apartment.orders.length - 1].type==="sold"&& translate("status.sold")}
                            {apartment.orders[apartment.orders.length - 1].type==="not_full_paid"&& translate("status.not_paid")}
                            {apartment.orders[apartment.orders.length - 1].type==="reserved"&& translate("status.booked")}
                            {apartment.orders[apartment.orders.length - 1].type==="reserved_paid"&& translate("status.booked")}

                        </p>
                                <Space>
                                    <b>{translate("sale.user")}</b>
                                    <p>
                                        {apartment.orders[apartment.orders.length - 1]?.user?.username}{" "}

                                    </p>
                                </Space>
                                <br/>
                                <Space>
                                    <b>{translate("sale.customer_name")}</b>
                                    <p  style={{wordBreak: "break-all"}}>
                                        <span className={styles.lineClamp}>
                                        {apartment.orders[apartment.orders.length - 1]?.client?.customerName}
                                        </span>
                                    </p>
                                </Space>
                            </>
                            :
                            <>
                                <p>
                                    {/*{translate("apartment.price")}*/}
                                    <b>{formatPrice(apartment, rate)} {translate("misc.currency")}</b>
                                </p>
                                <p>
                                    {/*{translate("apartment.area")}{" "}*/}
                                    <b>
                                        {parseFloat(apartment.m2)}{translate("misc.sqm")}
                                    </b>
                                </p>
                                <p>
                                    {/*{translate("apartment.price")}*/}
                                    <b>{formatPrice(apartment, rate, null, null, null, null, null, false, true)} {translate("misc.currency")}</b>
                                </p>
                                <p>
                                    {/*{translate("apartment.price")}*/}
                                    <b style={{whiteSpace:"break-spaces"}}>{apartment?.type}</b>
                                </p>
                            </>
                    }


                </>
      }

    </div>
  );
}
